import { Accounting } from "../gateway/Accounting/Accounting";

export class AccountingHasIntegrationUsecase {
    constructor() {
        this.AccountingGateway = new Accounting();
    }

    async execute({ accountingId, software }) {
        if (!accountingId || !software) return false;
        try {
            const accounting = await this.AccountingGateway.getById(
                accountingId
            );

            if (accounting?.integrations?.[software]?.firstIntegration)
                return true;
            return false;
        } catch (error) {
            return false;
        }
    }
}
